"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingDimensionsPatchSchema = void 0;
exports.TrackingDimensionsPatchSchema = {
    "$id": "https://www.redbull.com/schemas/patch/trackingDimensions.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TrackingDimensionsPatch",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "rrn:content:[a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}"
        },
        "type": {
            "type": "string",
            "pattern": "rrn:patch:trackingDimensions"
        },
        "meta": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "trackingDimensions": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                        "assetID": {
                            "type": "string",
                            "description": "the content resource ID",
                            "pattern": "rrn:content:[A-Za-z-]*:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}"
                        },
                        "chapter": {
                            "type": "string",
                            "description": "Lists all the chapters a content resource was tagged with (directly or via broader). Chapter can be identified using the tag subtype 'chapter'"
                        },
                        "contentLanguageLocale": {
                            "type": "string",
                            "description": "The language of the content resource, derived from the content resource URI. Format 'en_us' or 'en' for international content resources.",
                            "examples": [
                                "de_at"
                            ],
                            "pattern": "[a-z]{2}(_[a-z]{2,3})?"
                        },
                        "contentNumberOfPhotos": {
                            "type": "string",
                            "description": "Range number of images found in the body of a content resource object"
                        },
                        "contentNumberOfSocialEmbeddings": {
                            "type": "string",
                            "description": "Range number of social embeds found in the body of a content resource object"
                        },
                        "contentNumberofVideos": {
                            "type": "string",
                            "description": "Range number of videos found in the body of a content resource object"
                        },
                        "contentNumberofWords": {
                            "type": "string",
                            "description": "Range number of words found in the body of a content resource object"
                        },
                        "createdLanguageLocale": {
                            "type": "string",
                            "description": "Shows the language and locale of the country that originally created the content (will match contentLanguageLocale if 'created', or will be different if it is a translation). This allows analysis of the impact of translations of a story. Format 'en_us' or 'en' for international content",
                            "examples": [
                                "en_us"
                            ],
                            "pattern": "[a-z]{2}(_[a-z]{2,3})?"
                        },
                        "createdVsTranslated": {
                            "type": "string",
                            "description": "`translated` if a content resource was translated (translatedFrom relationship set), otherwise `created` should be used",
                            "enum": [
                                "created",
                                "translated"
                            ]
                        },
                        "disciplinesAerial": {
                            "type": "string",
                            "description": "Lists all tag-labels (combinded by comma) a content resource was tagged with below the aerial pseudogroup",
                            "examples": [
                                "surfing,free-diving"
                            ]
                        },
                        "disciplinesAll": {
                            "type": "string",
                            "description": "Lists all tag-labels in en-INT of all tags of subType 'discipline' a content resource (or its children) is tagged with. Multiple values are separated with a comma.",
                            "examples": [
                                "enduro,bmx,surfing,snowboarding"
                            ]
                        },
                        "disciplinesBike": {
                            "type": "string",
                            "description": "Lists all tag-labels (combinded by comma) a content resource was tagged with below the bike pseudogroup",
                            "examples": [
                                "mtb,bmx"
                            ]
                        },
                        "disciplinesCulture": {
                            "type": "string",
                            "description": "Lists all tag-labels (combinded by comma) a content resource was tagged with below the culture pseudogroup",
                            "examples": [
                                "games,ps3,dance,music,nightlife,film,fashon"
                            ]
                        },
                        "disciplinesESports": {
                            "type": "string",
                            "description": "Lists all tag-labels (combinded by comma) a content resource was tagged with below the ESports pseudogroup",
                            "examples": [
                                "valve,fifa,moba,street-fighter"
                            ]
                        },
                        "disciplinesMotorsports": {
                            "type": "string",
                            "description": "Lists all tag-labels (combinded by comma) a content resource was tagged with below the motorsports pseudogroup",
                            "examples": [
                                "enduro,superbike"
                            ]
                        },
                        "disciplinesOtherSports": {
                            "type": "string",
                            "description": "Lists all tag-labels (combinded by comma) a content resource was tagged with below the watersprots pseudogroup",
                            "examples": [
                                "golf,football,rugby,baseball,fitness-training,gymnastics,fun"
                            ]
                        },
                        "disciplinesPseudoGroup": {
                            "type": "string",
                            "description": "Lists all tag-labels in en-INT of all pseudogroups (tags of subtype 'discipline-pseudogroup') a content resource is tagged with. Multiple values are separated with a comma.",
                            "examples": [
                                "motorsports,bike,water-sports,winter-sports,skate,aerial,esports,other-sports,culture,games"
                            ]
                        },
                        "disciplinesPseudoGroup-combined": {
                            "type": "string",
                            "description": "Lists the tag-label in en-INT of the pseudo-group a content resource was tagged with. If more pseudo-groups apply, 'multi' is used.",
                            "examples": [
                                "multi"
                            ]
                        },
                        "disciplinesWaterSports": {
                            "type": "string",
                            "description": "Lists all tag-labels (combinded by comma) a content resource was tagged with below the watersprots pseudogroup",
                            "examples": [
                                "surfing,free-diving"
                            ]
                        },
                        "disciplinesWinterSports": {
                            "type": "string",
                            "description": "Lists all tag-labels (combinded by comma) a content resource was tagged with below the watersprots pseudogroup",
                            "examples": [
                                "surfing,free-diving"
                            ]
                        },
                        "label": {
                            "type": "string",
                            "description": "Lists all the labels a content resource was tagged with (directly or via broader). Labels can be identified using the tag subtype 'label'"
                        },
                        "labelGroup": {
                            "type": "string",
                            "description": "Lists all the label-groups a content resource was tagged with (directly or via broader). Label-groups can be identified using the tag subtype 'label-group'"
                        },
                        "localCustomGrouping": {
                            "type": "string",
                            "description": "attributes.contentClassificationTerms"
                        },
                        "masterID": {
                            "type": "string",
                            "description": "The traslatedFrom id. If a resource has not been translated, the content resource ID should be used instead.",
                            "pattern": "rrn:content:[A-Za-z-]*:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}"
                        },
                        "masterIDRB2": {
                            "type": "string",
                            "description": "legacy content id from RB2. resources that share the guid will also share the legacy content id",
                            "examples": [
                                "1331766995097"
                            ]
                        },
                        "mindset": {
                            "type": "string",
                            "description": "Lists all mindsets a content resource was tagged with (comma separated). Mindsets are not mandatory, so this will often be left blank (be populated with 'unspecified'). Mindsets can be identified through the tag subType",
                            "examples": [
                                "wings"
                            ]
                        },
                        "originalPublishingDate": {
                            "type": "string",
                            "description": "The date when a content was first published. Mapped from meta.dateCreated. Format is dd-mm-yyy",
                            "examples": [
                                "10-02-2016"
                            ]
                        },
                        "publishingDate": {
                            "type": "string",
                            "description": "The date when a content element was last updated. Mapped from meta.dateUpdated. Format is dd-mm-yyy",
                            "examples": [
                                "10-02-2016"
                            ]
                        },
                        "relatedEvents": {
                            "type": "string",
                            "description": "Comma-separated list of eventnames which are related to the content reosurce object"
                        },
                        "relatedPeople": {
                            "type": "string",
                            "description": "Comma-separated list of person names which are related to the content reosurce object"
                        },
                        "season": {
                            "type": "string",
                            "description": "Lists all the seasons a content resource was tagged with (directly or via broader). Seasons can be identified using the tag subtype 'season'"
                        },
                        "storyVideoReferenceIDs": {
                            "type": "string",
                            "description": "The content resource ids of all embeddedResources with `type rrn:content:videos*`",
                            "examples": [
                                "rrn:content:videos:e52c00be-46fd-4636-8b8e-ccd2667988cd:en-INT,rrn:content:videos:e52c00be-46fd-4636-8b8e-ccd2667988aa:en-INT"
                            ]
                        },
                        "targetAudiencePrimary": {
                            "type": "string",
                            "description": "Comma-separated list of primary audience labels"
                        },
                        "targetAudienceSecondary": {
                            "type": "string",
                            "description": "Comma-separated list of secondary audience labels"
                        }
                    },
                    "required": [
                        "assetID",
                        "chapter",
                        "contentLanguageLocale",
                        "createdLanguageLocale",
                        "createdVsTranslated",
                        "disciplinesAerial",
                        "disciplinesAll",
                        "disciplinesBike",
                        "disciplinesCulture",
                        "disciplinesESports",
                        "disciplinesMotorsports",
                        "disciplinesOtherSports",
                        "disciplinesPseudoGroup",
                        "disciplinesPseudoGroup-combined",
                        "disciplinesWaterSports",
                        "disciplinesWinterSports",
                        "label",
                        "labelGroup",
                        "localCustomGrouping",
                        "masterID",
                        "masterIDRB2",
                        "mindset",
                        "publishingDate",
                        "originalPublishingDate",
                        "season",
                        "storyVideoReferenceIDs"
                    ]
                }
            },
            "required": [
                "trackingDimensions"
            ]
        }
    },
    "required": [
        "id",
        "meta",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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